import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiPresetsService } from 'src/app/services/api-presets.service';
import { PresetValidator } from '../preset-create/preset-create.validators';

@Component({
  selector: 'app-preset-element-create',
  templateUrl: './preset-element-create.component.html',
  styleUrls: ['./preset-element-create.component.css']
})
export class PresetElementCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributes: any[] = [];
  attributeGroups: any[] = [];
  attributeValueTypes: any[] = [];
  attributePresentationTypes: any[] = [];

  form: UntypedFormGroup = this.fb.group({
    id:                           [null], 
    is_default:                   [false],
    attribute_group_id:           [null, this.validator.attribute_group_id], 
    attribute_id:                 [null, this.validator.attribute_id], 
    attribute_value_type:         [null, this.validator.attribute_value_type], 
    attr_group_order_num:         [null],
    attr_order_num:               [null],
    attr_present_type_id:         [null, this.validator.attr_present_type_id],
    selectors:                    [null],
    front_field_attrs:            [null],
    autocomplete_func:            [null],
    attr_value_mask:              [null],
    attr_value_mask_err_message:  [null],
    attribute_preset_value:       [null],
    attribute_preset_value_type:  [null],
    attribute_values_max_count:   [null],
    mandatory:                    [false],
    visible:                      [false],
    readonly:                     [false],
    translation:                  [false]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiPresets: ApiPresetsService,
    private notification: NotificationService,
    private validator: PresetValidator,
    private validatorService: ValidatorsService
  
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getAttributes();
    this.getAttributeGroup();
    this.getAttributeTypes();
    this.getAttributePresentationTypes();


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngDestroy(){
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
   getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
   getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeGroups = response.result;
        }
      })
    );

  }

  /**
   * 
   */
   getAttributeTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_value_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeValueTypes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
   getAttributePresentationTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_presentation_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributePresentationTypes = response.result;
        }
      })
    );

  }


  /**
   * 
   */
  onCreate(): void {

    console.log('form: ', this.form.value);

    this.progressRef.start();

    this.subscriptions.add(
      this.apiPresets.create(this.form.value).subscribe((response: Res) => { console.log('[RESPONSE] CREATE PRESET: ', response);
          
        if(response != null){
        
          // this.router.navigate(['organizations']);
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   * @param field 
   * @param type 
   */
   validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }
}
